<style scoped>
</style>

<template>
</template>

<script>
  export default {
    created () {
      this.sair()
    },
    methods: {
      sair () {
        this.$air.sair()
        this.$root.$emit('acessar')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Logout.vue